import React from "react";
// import { Link } from "react-router-dom";
// import { slugify } from '../../../utils';

const IncreasedSizeClientPropOne = ({ projectStyle, portfolio }) => {
  return (
    <>
      <div className={`client-grid2 ${projectStyle}`}>
        <div className="thumbnail5">
          {/* <Link to={process.env.PUBLIC_URL + `/`}> */}
            <img src={process.env.PUBLIC_URL + portfolio.image} alt="icon" />
          {/* </Link> */}
        </div>
        
      </div>
    </>
  );
};

export default IncreasedSizeClientPropOne;
